module.exports = __webpack_public_path__ + "static/img/vip.d0fabc8b.png";